import { jsx as e } from "react/jsx-runtime";
import { hiddenStripePaymentElementTermsOptions as t } from "../constants/stripe-payment-element-options.mjs";
import { useStripe as i, PaymentElement as n } from "../../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
function p() {
  return i() ? /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(
    n,
    {
      options: {
        ...t,
        fields: {
          billingDetails: {
            name: "never",
            email: "never"
          }
        }
      }
    }
  ) }) : null;
}
export {
  p as StripeBancontactDetails
};
